(function () {
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


var $dbfc10428e84f2a3$export$23a7ffc9cfbefc05 = 4;
var $dbfc10428e84f2a3$export$8ae71851ce4167cd = 2;
var $dbfc10428e84f2a3$export$df1fa4711fa5f9ac = 2;
var $dbfc10428e84f2a3$export$c80850304c13fa10 = 2;
var $dbfc10428e84f2a3$export$995d27d226b8d92c = 2048;
var $dbfc10428e84f2a3$export$6ea81d70350bed43 = [
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
];


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $dbfc10428e84f2a3$export$6ea81d70350bed43);
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.board = initialState;
        this.score = 0;
        this.newTile = null;
        this.mergedTiles = [];
        this.field = document.querySelector(".game-field");
        if (!this.field) throw new Error("\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0435\u043B\u0435\u043C\u0435\u043D\u0442 .game-field \u0432 DOM!");
        this.initBoard();
        this.renderBoard();
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "filterZero",
            value: function filterZero(row) {
                return row.filter(function(num) {
                    return num !== 0;
                });
            }
        },
        {
            key: "initBoard",
            value: function initBoard() {
                this.cells = [];
                this.field.innerHTML = "";
                for(var row = 0; row < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); row++){
                    this.cells[row] = [];
                    for(var col = 0; col < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); col++){
                        var cell = document.createElement("div");
                        cell.classList.add("field-cell");
                        this.field.appendChild(cell);
                        this.cells[row][col] = cell;
                    }
                }
            }
        },
        {
            key: "renderBoard",
            value: function renderBoard() {
                for(var row = 0; row < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); row++){
                    var _this, _loop = function(col) {
                        var cell = _this.cells[row][col];
                        var value = _this.board[row][col];
                        cell.textContent = value || "";
                        cell.className = "field-cell".concat(value ? " field-cell--".concat(value) : "");
                        if (_this.newTile && _this.newTile.row === row && _this.newTile.col === col) {
                            cell.classList.add("field-cell--new");
                            cell.addEventListener("animationend", function() {
                                return cell.classList.remove("field-cell--new");
                            }, {
                                once: true
                            });
                        }
                    };
                    for(var col = 0; col < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); col++)_this = this, _loop(col);
                }
                var scoreEl = document.querySelector(".game-score");
                if (scoreEl) scoreEl.textContent = String(this.score);
            }
        },
        {
            key: "spawnNumber",
            value: function spawnNumber() {
                var emptyCells = [];
                for(var row = 0; row < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); row++){
                    for(var col = 0; col < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); col++)if (this.board[row][col] === 0) emptyCells.push({
                        row: row,
                        col: col
                    });
                }
                if (emptyCells.length === 0) return;
                var randCell = emptyCells[Math.floor(Math.random() * emptyCells.length)];
                var numberToSpawn = Math.random() < 0.1 ? (0, $dbfc10428e84f2a3$export$df1fa4711fa5f9ac) : (0, $dbfc10428e84f2a3$export$8ae71851ce4167cd);
                this.board[randCell.row][randCell.col] = numberToSpawn;
                this.newTile = randCell;
                this.renderBoard();
                this.newTile = null;
            }
        },
        {
            key: "isGameOver",
            value: function isGameOver() {
                for(var row = 0; row < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); row++)for(var col = 0; col < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); col++){
                    if (this.board[row][col] === (0, $dbfc10428e84f2a3$export$995d27d226b8d92c)) return "win";
                }
                for(var row1 = 0; row1 < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); row1++)for(var col1 = 0; col1 < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); col1++){
                    if (this.board[row1][col1] === 0) return "playing";
                    if (col1 < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05) - 1 && this.board[row1][col1] === this.board[row1][col1 + 1]) return "playing";
                    if (row1 < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05) - 1 && this.board[row1][col1] === this.board[row1 + 1][col1]) return "playing";
                }
                return "lose";
            }
        },
        {
            key: "boardsAreEqual",
            value: function boardsAreEqual(board1, board2) {
                for(var i = 0; i < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); i++)for(var j = 0; j < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); j++){
                    if (board1[i][j] !== board2[i][j]) return false;
                }
                return true;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var prevBoard = JSON.parse(JSON.stringify(this.board));
                for(var i = 0; i < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); i++){
                    var row = this.board[i];
                    row = this.filterZero(row);
                    for(var j = 0; j < row.length - 1; j++)if (row[j] === row[j + 1]) {
                        row[j] *= 2;
                        row[j + 1] = 0;
                        this.score += row[j];
                        this.mergedTiles.push({
                            row: i,
                            col: j
                        });
                    }
                    row = this.filterZero(row);
                    while(row.length < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05))row.push(0);
                    this.board[i] = row;
                }
                this.renderBoard();
                if (!this.boardsAreEqual(prevBoard, this.board)) this.spawnNumber();
                this.checkGameStatus();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var prevBoard = JSON.parse(JSON.stringify(this.board));
                for(var i = 0; i < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); i++){
                    var row = this.board[i].reverse();
                    row = this.filterZero(row);
                    for(var j = 0; j < row.length - 1; j++)if (row[j] === row[j + 1]) {
                        row[j] *= 2;
                        row[j + 1] = 0;
                        this.score += row[j];
                        this.mergedTiles.push({
                            row: i,
                            col: 3 - j
                        });
                    }
                    row = this.filterZero(row);
                    while(row.length < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05))row.push(0);
                    this.board[i] = row.reverse();
                }
                this.renderBoard();
                if (!this.boardsAreEqual(prevBoard, this.board)) this.spawnNumber();
                this.checkGameStatus();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var prevBoard = JSON.parse(JSON.stringify(this.board));
                this.mergedTiles = [];
                for(var col = 0; col < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); col++){
                    var column = [];
                    for(var row = 0; row < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); row++)column.push(this.board[row][col]);
                    column = this.filterZero(column);
                    for(var i = 0; i < column.length - 1; i++)if (column[i] === column[i + 1]) {
                        column[i] *= 2;
                        column[i + 1] = 0;
                        this.score += column[i];
                        this.mergedTiles.push({
                            row: i,
                            col: col
                        });
                    }
                    column = this.filterZero(column);
                    while(column.length < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05))column.push(0);
                    for(var row1 = 0; row1 < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); row1++)this.board[row1][col] = column[row1];
                }
                this.renderBoard();
                if (!this.boardsAreEqual(prevBoard, this.board)) this.spawnNumber();
                this.checkGameStatus();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var prevBoard = JSON.parse(JSON.stringify(this.board));
                this.mergedTiles = [];
                for(var col = 0; col < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); col++){
                    var column = [];
                    for(var row = 0; row < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); row++)column.push(this.board[row][col]);
                    column = this.filterZero(column);
                    column.reverse();
                    for(var i = 0; i < column.length - 1; i++)if (column[i] === column[i + 1]) {
                        column[i] *= 2;
                        column[i + 1] = 0;
                        this.score += column[i];
                        this.mergedTiles.push({
                            row: 3 - i,
                            col: col
                        });
                    }
                    column = this.filterZero(column);
                    while(column.length < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05))column.push(0);
                    column.reverse();
                    for(var row1 = 0; row1 < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); row1++)this.board[row1][col] = column[row1];
                }
                this.renderBoard();
                if (!this.boardsAreEqual(prevBoard, this.board)) this.spawnNumber();
                this.checkGameStatus();
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                var messageContainer = document.querySelector(".message-container");
                var visibleMessage = messageContainer.querySelector("p:not(.hidden)");
                if (visibleMessage) {
                    if (visibleMessage.classList.contains("message-start")) return "idle";
                    if (visibleMessage.classList.contains("message-win")) return "win";
                    if (visibleMessage.classList.contains("message-lose")) return "lose";
                } else return "playing";
            }
        },
        {
            key: "checkGameStatus",
            value: function checkGameStatus() {
                var curStatus = this.isGameOver();
                if (curStatus === "win" || curStatus === "lose") this.showMessage(curStatus);
            }
        },
        {
            key: "showMessage",
            value: function showMessage(type) {
                var message = document.querySelector(".message.message-".concat(type));
                message.classList.remove("hidden");
                document.removeEventListener("keydown", this.boundKeyDown);
            }
        },
        {
            key: "start",
            value: function start() {
                this.initBoard();
                this.spawnNumber();
                this.spawnNumber();
                var footerMessage = document.querySelectorAll(".message");
                footerMessage.forEach(function(element) {
                    return element.classList.add("hidden");
                });
                this.boundKeyDown = this.keyDown.bind(this);
                document.addEventListener("keydown", this.boundKeyDown);
            }
        },
        {
            key: "restart",
            value: function restart() {
                var _document_querySelector, _document_querySelector1, _document_querySelector2;
                for(var row = 0; row < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); row++)for(var col = 0; col < (0, $dbfc10428e84f2a3$export$23a7ffc9cfbefc05); col++){
                    this.board[row][col] = 0;
                    var cell = this.cells[row][col];
                    cell.textContent = "";
                    cell.className = "field-cell";
                }
                (_document_querySelector = document.querySelector(".message.message-lose")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.add("hidden");
                (_document_querySelector1 = document.querySelector(".message.message-win")) === null || _document_querySelector1 === void 0 ? void 0 : _document_querySelector1.classList.add("hidden");
                (_document_querySelector2 = document.querySelector(".message.message-start")) === null || _document_querySelector2 === void 0 ? void 0 : _document_querySelector2.classList.add("hidden");
                document.removeEventListener("keydown", this.boundKeyDown);
                this.newTile = null;
                this.score = 0;
                this.renderBoard();
                this.spawnNumber();
                this.spawnNumber();
                this.boundKeyDown = this.keyDown.bind(this);
                document.addEventListener("keydown", this.boundKeyDown);
            }
        },
        {
            key: "keyDown",
            value: function keyDown(e) {
                e.preventDefault();
                switch(e.key){
                    case "ArrowUp":
                        this.moveUp();
                        break;
                    case "ArrowDown":
                        this.moveDown();
                        break;
                    case "ArrowLeft":
                        this.moveLeft();
                        break;
                    case "ArrowRight":
                        this.moveRight();
                        break;
                }
                this.checkGameStatus();
            }
        }
    ]);
    return Game;
}();
var $3d28d7f1aac198f5$export$2e2bcd8739ae039 = $3d28d7f1aac198f5$var$Game;


"use strict";
var $197cd56b15c33885$var$game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
var $197cd56b15c33885$var$startButton = document.querySelector("button.start");
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.classList.add("restart");
        $197cd56b15c33885$var$startButton.textContent = "Restart";
        $197cd56b15c33885$var$game.start();
    } else {
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.classList.add("restart");
        $197cd56b15c33885$var$startButton.textContent = "Restart";
        $197cd56b15c33885$var$game.restart();
    }
});

})();
//# sourceMappingURL=2048-game.a8e01888.js.map
